/*
## Synopsis:
This helper provides and allows for overriding of the standard button classes by returning a string
with the appropriate class names The default values create a medium, dark blue button.

### Usage - Component Level:
At the component level--the Save component in this example--you can set a default ({color: 'green'}),
as well as allow for overrides when using the component at the layout level (this.props.button).

``` return <button className={button(this.props.button, {color: 'green'})}>{label}</button>;


### Usage - Layout Level:
At the layout level--where you are using a component--you can pass in any additional overrides:

``` <Save form={this.state} button={{size: 'small'}} />

*/
import 'common/buttons.scss';

const defaults = {
    color: 'blue',
    size: 'medium',
};

export default function btn(...options) {
    const final = _.defaults(_.defaults({}, ...options), defaults);

    return 'btn ' + _.map(final, function(value, key) {
        return 'btn--' + key + '_' + value;
    }).join(' ');
}



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/layout/btn.js
 **/